import { ENTRY_TYPE } from 'src/pages/patrimony/PatrimonyPortfolio/tabs/PatrimonyPortfolioEstimation/PatrimonyPortfolioEstimation.const'
import { translate } from 'src/plugins/i18n'
import type { BudgetItemModel } from 'src/tpbp-json-api-handler/models/models'

export function budgetItemFieldDynamicLabel(record: BudgetItemModel) {
  const i18nPath = 'models.budget_items.fields'
  if (record.entryType === ENTRY_TYPE.liability)
    return translate(i18nPath + '.yearlyTaxableExpense')
  return translate(i18nPath + '.yearlyTaxableIncome')
}
